export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.916ca591.jpg";